import { gql } from '@apollo/client';

export const GET_NEAR_BY_DRIVERS = gql`
  query GetNearbyDrivers($latitude: Float!, $longitude: Float!, $serviceType: String!, $provider: String!, $showAll: Boolean, $scheduleDate: Date, $companyId: ID, $maxDistance: Int, $paymentIntentId: String, $filterBy: String, $estimatedPrice: Int, $options: [ID], $lastLocationUpdated: Int, $tripId: ID) {
    getNearbyDrivers(latitude: $latitude, longitude: $longitude, service_type: $serviceType, provider: $provider, show_all: $showAll, schedule_date: $scheduleDate, company_id: $companyId, max_distance: $maxDistance, payment_intent_id: $paymentIntentId, filter_by: $filterBy, estimated_price: $estimatedPrice, options: $options, last_location_updated: $lastLocationUpdated, trip_id: $tripId) {
      first_name
      id
      is_online
      last_name
      profile_picture
      email
      country_code
      phone_number
      share_code
      photo_icon
      gender
      enabled
      already_enabled
      mobile_verified
      email_verified
      type
      rating
      vehicle {
        id
        make
        model
        year
        registration_number
        colour
        ev
        license
      }
      address
      country
      city
      post_code
      dob
      social_security_number
      driving_license_number
      passport_id
      company_id
      vat_number
      kyc_submited
      kyc_url
      account_id
      customer_id
      current_device_id
      license
      distance
      driver_price
      blacklane_id
      blacklane_status
      ono_id
      carma_id
      created_at
      currency
      currency_symbol
    }
  }
`